export default __webpack_public_path__ + "static/DSC_0052-2cc63d0beb64d022e5059b217448f368.jpg";